export default __webpack_public_path__ + "static/media/kinder4.99b08bbb.jpg";